import { cn } from '@utils/cn'

export type ButtonVariant = 'primary' | 'ghost'

const BASE =
  'inline-block cursor-pointer rounded-sm px-6 py-3 font-display text-xs font-bold tracking-wide-label uppercase transition-all'

const VARIANT: Record<ButtonVariant, string> = {
  primary:
    'border border-arcane/55 bg-btn-grad text-bright shadow-glow hover:border-arcane/85 hover:shadow-glow-strong',
  ghost:
    'border border-steel/35 text-arcane-bright hover:border-arcane/70 hover:bg-arcane/10 hover:text-bright',
}

/**
 * Class recipe for button-shaped elements. Lives outside Button.tsx so router `<Link>`s can
 * dress as CTAs without wrapping (and react-refresh keeps its components-only export rule).
 */
export function buttonClasses(variant: ButtonVariant = 'primary', className?: string): string {
  return cn(BASE, VARIANT[variant], className)
}
